import PropTypes from 'prop-types';
import CustomizePackageModal from '../CustomizeAction/CustomizePackageModal';
import { AlloyButton, Modal, useModal } from 'cat-ecommerce-alloy';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import { useDispatch } from 'react-redux';
import { RESET_PRICE_AND_AVAILABILITY } from '@app/store/products/constants';
import { useAddToCart } from '@app/hooks';
import {
  ADD_TO_CART_ONCOMPLETE_RENDER,
  BUTTON_SIZES,
  BUTTON_VARIANTS
} from '@app/constants/commonConstants';
import { CatButton } from '@blocks-react/components/Button';

const CustomizeAction = ({
  showQuantityInput,
  showSmallVariant,
  selectedQuantity,
  isBundle,
  gaListName,
  quantity,
  disabled,
  isIndirectReplacement = false,
  showAddtoCartButtonOnly = false
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { isOpen, open, close } = useModal();

  const label = isBundle ? t('BUNDLE_PDP_CUSTOMIZE') : t('KITS_CUSTOMIZE_KIT');

  // * Lifted this state to make modal unable to close when adding item to cart
  const { addToCart: addItemsToCart, loading: loadingAddItemsToCart } =
    useAddToCart(ADD_TO_CART_ONCOMPLETE_RENDER.SKIP);

  const onClose = () => {
    close();
    dispatch({ type: RESET_PRICE_AND_AVAILABILITY });
  };

  const getCustomizeButton = () =>
    showAddtoCartButtonOnly ? (
      <CatButton
        data-testid="CustomizeKitButton"
        inverted={true}
        onclick={open}
        variant={BUTTON_VARIANTS.CONTRAST}
        size={BUTTON_SIZES.SM}
        disabled={disabled}
      >
        {label}
      </CatButton>
    ) : (
      <AlloyButton
        buttonType="secondary"
        className="'w-100"
        disabled={disabled}
        onClick={open}
        size={showSmallVariant ? 'dynamic' : 'large'}
      >
        {label}
      </AlloyButton>
    );

  return (
    <>
      <Modal
        isOpen={isOpen}
        close={loadingAddItemsToCart ? undefined : onClose}
        contentLabel={label}
        title={label}
        variant="large"
      >
        <CustomizePackageModal
          selectedQuantity={selectedQuantity}
          isModalOpen={isOpen}
          closeModal={onClose}
          addItemsToCart={addItemsToCart}
          loadingAddItemsToCart={loadingAddItemsToCart}
          gaListName={gaListName}
          quantity={quantity}
        />
      </Modal>
      <div
        className={cx({
          'pt-lg-4 mt-lg-2 py-2 me-2 col-12 col-lg-auto pe-lg-0':
            !showSmallVariant &&
            !isIndirectReplacement &&
            !showAddtoCartButtonOnly,
          'pt-lg-2 py-2 me-2 col-12 col-lg-auto pe-lg-0': isIndirectReplacement,
          'py-1 me-2': showSmallVariant,
          'ps-lg-2': showQuantityInput && !showSmallVariant,
          'me-3': showAddtoCartButtonOnly
        })}
      >
        {getCustomizeButton()}
      </div>
    </>
  );
};

CustomizeAction.propTypes = {
  showQuantityInput: PropTypes.bool,
  showSmallVariant: PropTypes.bool,
  selectedQuantity: PropTypes.number,
  gaListName: PropTypes.string,
  quantity: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  disabled: PropTypes.bool,
  isBundle: PropTypes.bool,
  isIndirectReplacement: PropTypes.bool,
  showAddtoCartButtonOnly: PropTypes.bool
};

export default CustomizeAction;
